import { connectedStore } from '../../store';
import actions from '../actions';

const detachGlobal = (globalElement) => {
  const store = connectedStore.get();
  store.dispatch(actions.detachGlobal(globalElement));
};

export default detachGlobal;
